module.exports = __webpack_public_path__ + "img/5dea6c4.png";